// Alle opslagsleutels. Dit zijn bewust DEZELFDE namen als in de vorige (vanilla) versie,
// zodat bestaande gebruikers hun activiteiten, logboek, timer en instellingen behouden.

export const IDB_NAME = 'GameOnActivitiesDB';
export const IDB_VERSION = 1;
export const IDB_STORE = 'activities';

export const KEYS = {
  logs: 'gameon_activity_history_v1',
  activeTimer: 'gameon_active_timer_v1',
  weatherCache: 'gameon_weather_cache_v1',
  weatherCoords: 'gameon_weather_coords_v1',
  weatherSimulated: 'gameon_weather_simulated',
  weatherState: 'gameon_weather_state',
  weatherTemp: 'gameon_weather_temp',
  windSimulated: 'gameon_wind_simulated',
  windLevel: 'gameon_wind_level',
  windKmh: 'gameon_wind_kmh',
  customDatasetLoaded: 'gameon_custom_dataset_loaded',
  lastReshuffleIds: 'gameon_last_reshuffle_ids',
  activeTab: 'gameon_active_tab',
  /** Favorieten en verborgen activiteiten (JSON van Preferences, zie domain/prefs.ts). */
  prefs: 'gameon_prefs_v1',
  /** Laatst gekozen beschikbare tijd (minuten als getal-string, of leeg). */
  timeBudget: 'gameon_time_budget',
  /** Ontwikkelaarsmodus ('1' = aan). */
  devMode: 'gameon_dev_mode',
  /** Hash van de laatst geladen standaardlijst (gameon_activiteiten.md); verandert → niet-aangepaste lijst vernieuwen. */
  defaultsHash: 'gameon_defaults_hash',
  /** Weekdoel ({minutes, onlyOutdoor}) of afwezig = geen doel. */
  weeklyGoal: 'gameon_weekly_goal_v1',
  /** Id's van mijlpalen waarvan de melding al getoond is (JSON-array). */
  milestonesSeen: 'gameon_milestones_seen_v1',
  /** Oud: 'light' | 'dark' | 'auto' (als platte string, niet JSON). */
  themeMode: 'gameon_theme',
  /** Oud: 'default' | 'midnight_velvet' | 'aurora' | ... (platte string). */
  bgTheme: 'gameon_bg_theme',
} as const;
